import { FC } from 'react';
import ProductCard from '@/components/products/product-card/product-card';
import Carousel from '@/components/ui/carousel/carousel';
import useProductDetailPageContext from '@/hooks/use-product-detail-page-context';
import { useTranslation } from '@/providers/app-provider/app-provider';
import { mapProductToSimpleProductInfo } from '@/utils/map-product-to-simple-product-info';

const SimilarProducts: FC = () => {
  const { t } = useTranslation();

  const {
    product: { similars },
  } = useProductDetailPageContext();

  if (similars.length === 0) {
    return null;
  }

  return (
    <div className="mt-8 flex flex-col gap-4">
      <h2 className="text-2xl font-medium">{t?.productDetail.similarProducts}</h2>
      <div className="max-w-[85dvw] rounded-lg py-4 sm:mx-10">
        <Carousel
          slides={similars.map(p => mapProductToSimpleProductInfo(p))}
          options={{ align: 'center', slidesToScroll: 'auto' }}
        >
          {item => (
            <div className="flex-shrink-0 flex-grow-0" key={item.id}>
              <ProductCard product={item} />
            </div>
          )}
        </Carousel>
      </div>
    </div>
  );
};

export default SimilarProducts;
